/** Laravel serves JSON routes under `/api`. Avoid 404 "route api/auth/... not found" by ensuring BASE_URL always ends with `/api`. */
function normalizeApiBaseUrl(raw) {
  const fallback = "http://localhost:9000/api";
  const trimmed = (raw || "").trim().replace(/\/+$/, "");
  if (!trimmed) return fallback;
  return trimmed.endsWith("/api") ? trimmed : `${trimmed}/api`;
}

// API Configuration — REACT_APP_API_URL should be the API origin (with or without trailing `/api`).
export const API_CONFIG = {
  BASE_URL: normalizeApiBaseUrl(process.env.REACT_APP_API_URL),

  // Admin endpoints
  ADMIN: {
    LOGIN: "/auth/admin-login", // Admin or closet only; regular customers rejected
    DASHBOARD: "/admin/dashboard",
    USERS: "/admin/users",
    CUSTOMERS: "/admin/customers",
    PRODUCTS: "/admin/products",
    ORDERS: "/admin/orders",
    ABANDONED_CHECKOUTS: "/admin/abandoned-checkouts",
    RESERVATIONS: "/admin/reservations",
    CATEGORIES: "/admin/categories",
    CLOSET: "/admin/closet",
    PERMISSIONS: "/admin/permissions",
    EXPORT: {
      CUSTOMERS: "/admin/export/customers",
      USERS: "/admin/export/users",
      PRODUCTS: "/admin/export/products",
      CLOSET: "/admin/export/closet",
      ORDERS: "/admin/export/orders",
      ABANDONED_CHECKOUTS: "/admin/export/abandoned-checkouts",
      RESERVATIONS: "/admin/export/reservations",
    },
  },
};

export default API_CONFIG;
